import { createContext } from 'react';

const ClassroomContext = createContext();

export default ClassroomContext;